/**
 * 使用a标签打开新的标签页面-兼容部分浏览器拦截的问题
 * @param url 跳转的链接
 * @returns undefined
 */
export const openNewPage = (url: string, target = '_blank') => {
  if (typeof document === 'undefined') return;
  const node = document.createElement('a');
  node.setAttribute('target', target);
  node.setAttribute('href', url);
  node.click();
};
